import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import BSModal from "../../../../../../common/BSModal";

class DependentAutoUncheckModal extends React.Component {
  render() {
    const { show, onClose, guaranteeNames } = this.props;
    const isSingleGuarantee = guaranteeNames && guaranteeNames.length === 1;

    return (
      <BSModal
        show={show}
        onClose={onClose}
        title={
          <span>
            <FormattedMessage id="validation.clientFieldValidation.attention">
              {(f) => <span className="icon warning">{f}</span>}
            </FormattedMessage>
          </span>
        }
        closeButtonKey="memberCoverages.modal.dependent.confirmButton"
        backdrop={false}
      >
        <div>
          {isSingleGuarantee ? (
            <div>
              <h4>
                <FormattedMessage id="memberCoverages.modal.dependent.singleTitle" />
              </h4>
              <p style={{ whiteSdependente: "pre-wrap" }}>
                <FormattedMessage
                  id="memberCoverages.modal.dependent.singleMessage"
                  values={{ guaranteeName: guaranteeNames[0] }}
                />
              </p>
            </div>
          ) : (
            <div>
              <h4>
                <FormattedMessage id="memberCoverages.modal.dependent.multipleTitle" />
              </h4>
              <p>
                <FormattedMessage id="memberCoverages.modal.dependent.multipleMessageIntro" />
              </p>
              <ul>
                {guaranteeNames.map((name, idx) => (
                  <li key={idx}>{name}</li>
                ))}
              </ul>
              <p>
                <FormattedMessage id="memberCoverages.modal.dependent.multipleMessageOutro" />
              </p>
            </div>
          )}
        </div>
      </BSModal>
    );
  }
}

DependentAutoUncheckModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  guaranteeNames: PropTypes.array,
};

DependentAutoUncheckModal.contextTypes = {
  intl: intlShape,
};

export default DependentAutoUncheckModal;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/DependentAutoUncheckModal.js